<template>
  <page-layout
    :breadcrumbs="[
      {
        text: 'HOME',
        exact: true,
        to: { name: 'home' }
      },
      {
        text: nombreCategoria,
        disabled: true
      }
    ]"
    :titulo="nombreCategoria"
  >
    <v-container>
      <v-row>
        <v-col v-for="(video, i) in videos" :key="video.id" cols="12" sm="6" lg="4">
          <v-card @click="clickVideo(video.id)" class="pointer" style="border-radius: 5px">
            <v-row no-gutters>
              <v-col cols="12" :ref="'videoImg-' + i">
                <v-img
                  :src="video.src"
                  style="border-top-left-radius: 5px;border-top-right-radius: 5px"
                  :width="videoWidth"
                  :height="videoHeight"
                />
              </v-col>
              <v-col cols="12" class="pt-2 pb-3 px-2">
                <span class="subtitle-1">
                  {{ video.nombre }}
                </span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </page-layout>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'categoria',
  props: {
    id: {
      required: true,
      default: null
    }
  },
  data() {
    return {
      videoWidth: 0
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    this.videoWidth = this.$refs['videoImg-0'][0].clientWidth
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize)
  },
  computed: {
    ...mapGetters({
      getAllVideos: 'viralmobile/getAllVideos',
      getCategoriaById: 'viralmobile/getCategoriaById'
    }),
    videos() {
      return this.getAllVideos
        .filter(x => x.categoriaId == this.id)
        .map(x => {
          return {
            ...x,
            src: require('@/assets/images/videos/' + x.imagen)
          }
        })
    },
    categoria() {
      return this.getCategoriaById(this.id)
    },
    nombreCategoria() {
      return this.categoria ? this.categoria.nombre.toUpperCase() : '...'
    },
    videoHeight() {
      return this.videoWidth / 1.7778
    }
  },
  methods: {
    onResize() {
      this.videoWidth = this.$refs['videoImg-0'][0].clientWidth
    },
    clickVideo(id) {
      this.$router.push({ name: 'video', params: { categoriaId: this.id, videoId: id } })
    }
  }
}
</script>
